<template>
    <div>
        <!-- Sorting toggle -->
        <div class='facet-control'>
            <div class="sort btn-group btn-group-sm" data-toggle="buttons">
                <label @click='sort_num = true' class="btn btn-default active"><input type="radio">Frequency</label>
                <label @click='sort_num = false' class="btn btn-default"><input type="radio" checked>Alphabetical</label>
            </div>

            <!-- Search Input -->
            <input type="text" name="facet" class='form-control input-sm' placeholder='Search filter' v-model='search'>
        </div>

        <!-- List Options -->
        <div class='options'>
            <div v-for='option in options'>
                <label>
                    <input @change='filterResults'
                        :id='option.key'
                        :value='option.key'
                        v-model='manager.filters[name].selected'
                        type="checkbox"/>
                    <label :for='option.key'></label> {{manager.cleanHtml(option.key)}}
                    <span v-show='manager.filters[name].selected.indexOf(option.key) == -1'>
                         ({{option.doc_count}})
                    </span>
                </label>
            </div>
            <button v-show='options.length == 100' @click='seeAll' class='see-all btn btn-default btn-xs'>
                View more options
            </button>
        </div>

        <div v-show='options.length == 0'>
            No options apply
        </div>
    </div>
</template>

<script>
    import EventHub from '../eventHub.js'
    import FilterManager from './../filterManager.js'

    export default {
        props: ['name', 'filterResults'],
        watch: {
            'sort_num': 'sort',
            'search': 'sort'
        },
        data: function () {
            return {
                manager: FilterManager,
                options: [],
                search: null,
                sort_num: true,
            }
        },
        created: function () {
            EventHub.$on('refresh-facets', this.sort)
        },
        beforeDestroy: function () {
            EventHub.$off('refresh-facets')
        },
        methods: {
            seeAll: function () {
                EventHub.$emit('see-all-options', this.name)
            },
            // Sort filter options
            sort: function () {
                var self = this
                var query = $.extend(true, {}, this.$route.query)
                query.facet = this.name
                query.agg_sort_num = this.sort_num

                if (this.search) {
                    query.agg_search = this.search
                }

                // Make request for new facets
                $.get('/api/objects', query).done(function (response) {
                    response = $.parseJSON(response)
                    self.options = response.aggs[self.name].buckets
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .see-all {
        margin-bottom: 10px;
    }

    .facet-control {
        width: 100%;
        margin-bottom: 10px;

        div {
            width: 100%;
        }

        label {
            width: 50%;
        }

        input[name=facet] {
            width: 100%;
            background-image: url('/images/search_filter.svg');
            background-repeat: no-repeat;
            background-position: 97% 5px;
            background-size: 18px;
        }
    }

    .options {
        max-height: 200px;
        overflow: auto;
    }
</style>
